import { lazy } from 'react';

// ----------------------------------------------------------------------

const ReportsPage = lazy(() => import('../pages/Reports.page'));
const Student = lazy(() => import('../pages/student/Student'));
const CoursesAndProducts = lazy(() => import('../pages/courses-and-orders/CoursesAndProducts'));
const BranchesAndEmployees = lazy(() => import('../pages/branches-and-employees/BranchesAndEmployees'));
const Marketing = lazy(() => import('../pages/marketing/Marketing'));

// ----------------------------------------------------------------------

const ReportsRoutes = [
    {
        path: '/reports',
        element: <ReportsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/student',
        element: <Student />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/courses-and-products',
        element: <CoursesAndProducts />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/branches-and-employees',
        element: <BranchesAndEmployees />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/marketing',
        element: <Marketing />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ReportsRoutes };
